function FootArea(props: any) {
  let myProps = {
    Style: {},
    templete_data_json: {},
    ...props
  };
  let Style = myProps.Style || {};
  let templete_data_json = myProps.templete_data_json || {};

  return (
    <div className={Style.word_page_footer} >
      <span>
        {templete_data_json.select_date}
      </span>
      <span>
        {templete_data_json.comp_name}
      </span>
      <span>
        {templete_data_json.now_page_num + 1} / {templete_data_json.total_page_num}
      </span>
    </div>
  );
};
export default FootArea;